import { render, staticRenderFns } from "./MpesaStkModal.vue?vue&type=template&id=40503fd4"
import script from "./MpesaStkModal.vue?vue&type=script&lang=js"
export * from "./MpesaStkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports